var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 2.5V3.5H15.5V12.207L17.5 14.207V15.5H12.2998V21.2002C12.2997 21.3658 12.1656 21.5 12 21.5C11.8344 21.5 11.7003 21.3658 11.7002 21.2002V15.5H6.5V14.207L8.5 12.207V3.5H7.5V2.5H16.5Z",
    stroke: "#403C6F"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.35355,
    y1: 2.64645,
    x2: 21.3536,
    y2: 20.6464,
    stroke: "#403C6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiPin);
export default __webpack_public_path__ + "static/media/mdi_pin.60cfe2a4bde7175c321a5bea96a428df.svg";
export { ForwardRef as ReactComponent };